const WelcomeSection = ({ defaultVisibility }) => (
  <div className="w-full flex justify-center items-center">
    <div className="bg-black h-full w-full">
      <div className="md:px-10 px-5 pt-16 text-teal text-left">
        <p className="text-sm pb-2 inline-block">
          <span className="bg-teal text-black py-1 px-2">
            ~/Development/Portfolio
          </span>
          <span> </span>
          <span id="run-command"> npm run portfolio</span>
        </p>
        <p
          id="compiled-text"
          className={`text-sm text-lightgrey pb-5 ${defaultVisibility}`}
        >
          &gt; Compiled successfully!
        </p>
        <div id="about-info" className={`${defaultVisibility}`}>
          <p id="name" className="text-3xl font-bold">
            Marko Plaznik
          </p>
          <p className="text-lg">Software Engineer</p>
        </div>
        <div id="links" className={`pt-3 ${defaultVisibility}`}>
          <Link Name={"GitHub"} Link={"https://github.com/ohIcee"} />
          <Link Name={"Email"} Link={"mailto:icevx1@gmail.com"} />
        </div>
      </div>
    </div>
  </div>
);

const Link = ({ Name, Link }) => (
  <div className="relative inline mr-3">
    <a
      className="text-white before:absolute before:top-0 before:hover:bg-pink before:h-full before:w-full z-10"
      href={Link}
      target="_blank"
      rel="noreferrer"
    >
      <span className="relative">[ {Name} ]</span>
    </a>
  </div>
);

export default WelcomeSection;
